import { frontendURL } from 'dashboard/helper/URLHelper';

// The notifications inbox (mentions and assignment notices) is not part of
// this instance: old links land on "Mi bandeja de entrada" or the conversation.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/inbox-view'),
    name: 'inbox_view',
    redirect: to => ({
      name: 'conversation_mine',
      params: { accountId: to.params.accountId },
    }),
  },
  {
    path: frontendURL('accounts/:accountId/inbox-view/:type/:id'),
    name: 'inbox_view_conversation',
    redirect: to => ({
      name: 'inbox_conversation',
      params: {
        accountId: to.params.accountId,
        conversation_id: to.params.id,
      },
    }),
  },
];
